import SelectDropdownComponent from './SelectDropdown';

const SelectDropdown = SelectDropdownComponent;

export default SelectDropdown;
